'use client';

import { ReactNode, useRef, useEffect } from 'react';

import { useFilterSyncContext } from '../../hooks/FilterSyncContext';

import { styles } from './Layout.styles';

export interface LayoutProps {
  children: ReactNode;
  header: ReactNode;
  sidebar: ReactNode;
  stickyHeader: ReactNode;
}

export function Layout({
  children,
  header,
  sidebar,
  stickyHeader
}: LayoutProps) {
  const slots = styles();
  const stickyHeaderRef = useRef<HTMLDivElement>(null);
  const { isStickyVisible, setStickyHeaderRef } = useFilterSyncContext();

  // Устанавливаем ref для StickyHeader
  useEffect(() => {
    if (stickyHeaderRef.current) {
      setStickyHeaderRef(stickyHeaderRef.current);
    }
  }, [setStickyHeaderRef]);

  return (
    <div className={slots.base()}>
      <div
        ref={stickyHeaderRef}
        className={slots.stickyHeader()}
        style={{
          opacity: isStickyVisible ? 1 : 0,
          visibility: isStickyVisible ? 'visible' : 'hidden',
          pointerEvents: isStickyVisible ? 'auto' : 'none'
        }}
      >
        {stickyHeader}
      </div>
      <div className={slots.container()}>
        <div className={slots.header()}>{header}</div>
        <div className={slots.sidebarMobile()}>{sidebar}</div>

        <div className={slots.content()}>
          <div className={slots.main()}>{children}</div>
        </div>
      </div>

      <div className={slots.sidebar()}>
        <div className={slots.sidebarSticky()}>{sidebar}</div>
      </div>
    </div>
  );
}
